// extracted by mini-css-extract-plugin
export default {"buttonBorder":"ButtonBorder_buttonBorder__fQy7x","buttonBorderMobile":"ButtonBorder_buttonBorderMobile__T-oNa"};